import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HighlightConfig from 'lumen/models/roi-trophies/highlight-config';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export type HotelSettingsPersonalModel = {
  highlightConfig: HighlightConfig | null;
};

export default class HotelSettingsPersonalRoute extends Route {
  @service declare access: Services['access'];
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  @service declare store: Services['store'];

  async model(): Promise<HotelSettingsPersonalModel> {
    if (!this.access.hasTrophyHighlights) {
      return { highlightConfig: null };
    }

    try {
      const highlightConfig = await this.store.queryRecord<HighlightConfig>(
        'roi-trophies/highlight-config',
        {
          namespace: APIGATEWAY,
          typeKey: 'highlights/email/settings',
          subscription_id: this.hotelAndMarketService.hotel.id,
        },
      );

      return { highlightConfig };
    } catch (error) {
      this.errorTracking.captureException(error);

      return { highlightConfig: null };
    }
  }
}
